"use strict";

function QuantityInput(_ref) {
  var id = _ref.id,
      onUpdate = _ref.onUpdate;
  var qty = document.getElementById(id);
  var decrease = document.querySelector("#".concat(id, "-container .decreaseQty"));
  var increase = document.querySelector("#".concat(id, "-container .increaseQty"));
  var min = 1;
  var max = 99;
  var previousValue = null;

  var setQuantity = function setQuantity(value) {
    qty.value = value;
  };

  var handleQuantityUpdate = function handleQuantityUpdate(value) {
    if (value !== "") {
      if (value < min) {
        value = min;
      }

      if (value > max) {
        value = max;
      }
    }

    var hasChanged = value !== previousValue;
    var val = Number(value);

    if (val > 0 && previousValue !== val) {
      previousValue = val;
    }

    setQuantity(value);

    if (onUpdate && hasChanged) {
      onUpdate(val, previousValue);
    }
  };

  var decreaseQty = function decreaseQty() {
    handleQuantityUpdate(Number(qty.value) - 1);
  };

  var increaseQty = function increaseQty() {
    handleQuantityUpdate(Number(qty.value) + 1);
  };

  var handleInvalid = function handleInvalid(e) {
    var value = e.target.value;

    if (!(value > 0)) {
      setQuantity(previousValue);
    }
  };

  var handleKeyPress = function handleKeyPress(e) {
    var isNumeric = /[0-9]/.test(e.key);

    if (!isNumeric) {
      e.preventDefault();
    }
  };

  qty.addEventListener('change', function (e) {
    handleQuantityUpdate(e.target.value);
  });
  qty.addEventListener('blur', function (e) {
    handleInvalid(e);
  });
  qty.addEventListener('keypress', handleKeyPress);
  increase.addEventListener('click', increaseQty);
  decrease.addEventListener('click', decreaseQty);
}

;
"use strict";

function toggleMenu() {
  var header = document.querySelector('header.header');

  if (header.classList.contains('open')) {
    header.classList.remove('open');
  } else {
    header.classList.add('open');
  }
}